import { colors } from '@material-ui/core'

const white = '#FFFFFF'
const black = '#233154'
const primaryMain = '#233154'
const primaryLight = '#F3FAFF'
const primaryHover = '#0763A0'
const primaryTopBar = '#0763A0'
const secondaryDark = '#233154'
const secondaryMain = '#657786'
const secondaryLight = '#AAB8C2'
const secondarySuperLight = '#E1E8ED'
const backgroundDefault = '#F4F6F8'
const backgroundInputColor = '#F3FAFF'
const linkHelp = '#3024AE'
const menuTitle = '#233154'
const mainMenu = '#546E7A'

const textSecondaryTwo = '#2883BF'

const newAuth = '#48A1CA'
const azure = '#087DF1'
const azureTranslucent = '#087DF138'
const whiteBlue = '#F3FAFF'
const yellowOrange = '#FF9800'
const darkRed = '#B71C1C'
const greenPantone = '#80B92B'
const spanishGray = '#999999'
const teal = '#148585'
const blueViolet = '#671684'
const veryDarkGrayishBlue = '#343A40'
const grapePurple = '#BA2980'
const lightGray = '#EEE'
const cianDark = '#263238'

const yellowWarningLight = '#FFC107'
const yellowWarningDark = '#FFB03D'
const redErrorLight = '#F87B87'
const redErrorDark = '#DC3545'
const blueLight = '#60ACF8'
const blueDark = '#092A3B'
const greenLight = '#5DEE63'
const greenSnowFlurry = '#E3FFBA'
const greenDark = greenPantone
const greenPantoneLight = '#E3FFBB'
const pinkMagenta = '#F43D9E'
const dpoDayNavy = '#061436'
const dpoDayButtonNavy = '#081B49'
const trailWarning = '#2196F3'
const lightPastelBlue = '#E6F5FF'
const pastelOrange = '#ffd694'
const lightPastelYellow = '#fff7de'

const paper = '#E0E0E0'

const cardSummaryBackground = '#F0F0F0'
const lightBorder = '#DDDDDD'

const palette = {
  cardSummaryBackground,
  lightBorder,
  lightPastelBlue,
  black,
  white,
  azure,
  azureTranslucent,
  blueDark,
  blueLight,
  blueViolet,
  cianDark,
  darkRed,
  dpoDayNavy,
  dpoDayButtonNavy,
  grapePurple,
  greenDark,
  greenLight,
  greenPantone,
  greenPantoneLight,
  greenSnowFlurry,
  lightGray,
  lightPastelYellow,
  pastelOrange,
  pinkMagenta,
  redErrorDark,
  redErrorLight,
  spanishGray,
  teal,
  trailWarning,
  veryDarkGrayishBlue,
  whiteBlue,
  yellowOrange,
  yellowWarningDark,
  yellowWarningLight,
  common: {
    white: '#FFFFFF',
    black: '#000000',
  },
  primary: {
    contrastText: white,
    dark: colors.indigo[900],
    hover: primaryHover,
    light: primaryLight,
    main: primaryMain,
    newAuth: newAuth,
    topBar: primaryTopBar,
  },
  secondary: {
    contrastText: white,
    dark: secondaryDark,
    light: secondaryLight,
    main: secondaryMain,
    superLight: secondarySuperLight,
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    light: colors.green[400],
    main: colors.green[600],
  },
  tertiary: {
    main: '#80B92B',
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    light: colors.blue[400],
    main: colors.blue[600],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    light: colors.orange[400],
    main: colors.orange[600],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    light: colors.red[400],
    main: colors.red[600],
  },
  text: {
    backgroundInputColor: backgroundInputColor,
    link: colors.blue[600],
    linkHelp: linkHelp,
    mainMenu: mainMenu,
    menu: secondaryMain,
    menuTitle: menuTitle,
    primary: secondaryDark,
    secondary: secondaryMain,
  },
  categoryCard: {
    hoverColor: '#9A9AA0',
    mainColor: '#657786',
    selectedColor: '#006EA0',
    selectedHoverColor: '#007EB7',
  },
  statuses: {
    approved: '#16A63C',
    disapproved: '#E83A49',
    inactive: '#FCC109',
    pending: '#376FB6',
  },
  background: {
    default: backgroundDefault,
    paper: white,
    snackbar: '#E3FFBB',
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[300],
  navigator: {
    selectedColor: primaryTopBar,
    text: {
      primary: colors.grey[50],
      secondary: '#8CC9E4',
    },
    borderColor: 'transparent',
  },
  partnerGreen: {
    dark: '#097222',
    middle: '#6CC38A',
    light: '#D6FFE4',
  },
  partnerBlue: {
    dark: '#087DF1',
    middle: '#79B9F8',
    light: backgroundInputColor,
  },
  permission: {
    user: {
      main: '#A855F7',
      background: '#F5F3FF',
    },
    department: {
      main: '#22C55E',
      background: '#F0FDF4',
    },
    organization: {
      main: '#F97316',
      background: '#FFF7ED',
    },
  },
  subscription: {
    primary: {
      main: '#233154',
      light: '#B8DAF7',
      dark: '#076EA0',
    },
    warning: {
      error: '#e83a49',
      success: '#80B92B',
      alert: '#fcc109',
      info: {
        main: '#376fb6',
        secondary: ' #9f9e9e',
      },
    },
  },
  dashboard: {
    main: '#096fa1',
    text: '#7e929b',
    report: {
      text: {
        secondary: textSecondaryTwo,
      },
    },
    chart: {
      primary: {
        approved: '#16A63C',
        disapproved: '#E83A49',
        inactive: '#9F9E9E',
        pending: '#376FB6',
        revision: '#FCC109',
        inProgress: '#FF7A00',
        treated: '#AADD5F',
        reviewLia: '#FFEBAC',
        disapprovedLia: '#FF8A8A',
      },
      secondary: {
        approved: '#87F3A4',
        pending: '#B8DAF7',
        disapproved: '#FF8A8A',
        revision: '#FFEBAC',
      },
      label: '#657786',
      measures: {
        adopted: '#16A63C',
        pending: '#FF7A00',
        overdue: '#E83A49',
        riskAssumed: '#FECC31',
        treated: '#AADD5F',
        inProgress: '#0763A0',
        inactive: '#546E7A',
      },
      training: {
        concluded: '#0763A0',
        notConcluded: '#E83A494D',
      },
      consents: {
        authorized: '#80B92B',
        revoked: '#FF7A0033',
      },
      cookies: {
        accepted: '#4199D2',
        partial: '#FC8ACE',
        denied: '#FF7A0033',
      },
      privacyPolicy: {
        privacyPortal: '#FECC31',
        app: '#FF7A0033',
        both: '#E83A494D',
        none: '#aaaaaa33',
      },
      ticket: {
        pending: '#376FB6',
        finalized: '#AADD5F',
        canceled: '#E83A494D',
        overdue: '#FCC109',
        replied: '#9F9E9E',
      },
      phishing: {
        delivered: '#0763A0',
        viewed: '#376FB6',
        clicks: '#FCC109',
        compromised: '#E83A49',
      },
    },
    card: {
      incident: {
        main: '#c10d1a',
        secondary: '#ff8a8a',
      },
      gradient: {
        main: '#46a0c9',
      },
    },
    icons: {
      blue: '#096fa1',
      green: '#16A63C',
    },
  },
  marketplace: {
    card: {
      hover: colors.grey[100],
      border: '#4199D2',
    },
    banner: {
      cookies: '#243155',
    },
    section: {
      moreDetails: '#80B92C',
    },
  },
  code: {
    background: '#ECECEC',
  },
  layout: {
    main: '#243155',
    secondary: '#0763A0',
    textPrimary: colors.grey[50],
  },
  fragility: {
    undefined: '#A9A9A9',
    low: '#4CAF50',
    medium: '#ACCA2E',
    high: '#F4A460',
    severe: '#E53935',
  },
  paper: {
    border: paper,
  },
  custom: {
    light: '#E7F2FB',
    main: '#6FA2CF',
    dark: '#657786',
    superDark: '#2E373E',
    border: '#E0E0E0',
    disabled: '#97989A',
  },
  neutral: {
    main: '#546E7A',
  },
  statusLabel: {
    success: {
      primary: '#16A63C',
      secondary: '#B4FFC8',
    },
    error: {
      primary: '#DC3545',
      secondary: '#FFE0E3',
    },
    pending: {
      primary: '#376FB6',
      secondary: '#B8DAF7',
    },
    warning: {
      primary: '#E0A800',
      secondary: '#FFF4CC',
    },
    softDeleted: {
      primary: '#0f0e0e',
      secondary: '#b6b6b6',
    },
  },
  cardFlags: {
    amex: {
      primary: '#1F72CD',
      grayscale: '#757575',
    },
  },
  textfield: {
    border: '#0000003A',
  },
  dai: {
    shinyBlue: '#59B1E7',
    dark: '#3E94CC',
    light: '#99D6FE',
    lightBlue: '#D6EDFB',
    title: '#2883BF',
    glow: '#67B6EA73',
  },
  phishing: {
    difficulty: {
      easy: { background: '#e6f9f0', text: '#1a7f4b' },
      medium: { background: '#fff8e1', text: '#b06a00' },
      hard: { background: '#fdecea', text: '#b71c1c' },
    },
    statCardValue: '#1e2a5e',
  },
  gmail: {
    topBarBackground: '#1a237e',
    lightBlue: '#e8f0fe',
    blue: '#1a73e8',
  },
  companySupplier: {
    progressStatus: {
      pending: {
        color: '#376FB6',
        backgroundColor: '#B8DAF7',
      },
      inProgress: {
        color: '#FF7A00',
        backgroundColor: '#FFE0B2',
      },
      completed: {
        color: '#16A63C',
        backgroundColor: '#B4FFC8',
      },
      overdue: {
        color: '#DC3545',
        backgroundColor: '#FFE0E3',
      },
    },
    status: {
      inactive: {
        color: '#ECEFF1',
        backgroundColor: '#546E7A',
      },
    },
  },
}

export default palette
